import { render, staticRenderFns } from "./MaterialTemplatesPage.vue?vue&type=template&id=bf341b80&scoped=true"
import script from "./MaterialTemplatesPage.vue?vue&type=script&lang=ts"
export * from "./MaterialTemplatesPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialTemplatesPage.vue?vue&type=style&index=0&id=bf341b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf341b80",
  null
  
)

export default component.exports